import {Injectable} from '@angular/core';
import {fetchAuthSession, signInWithRedirect} from '@aws-amplify/auth';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  /**
   * Checks whether the user has a valid session, redirecting to the Cognito
   * Hosted UI if not. Intended for use from a route guard.
   */
  public async authorize(): Promise<boolean> {
    const session = await fetchAuthSession();

    if (session.tokens) {
      return true;
    }

    await signInWithRedirect({});
    return false;
  }

  /**
   * Unlike homey-admin-app's AuthService, this does not cache the access
   * token in a field. It calls fetchAuthSession() on demand every time so
   * Amplify can transparently refresh an expired token.
   */
  public async getAccessToken(): Promise<string | undefined> {
    const session = await fetchAuthSession();
    return session.tokens?.accessToken.toString();
  }
}
